import { atom } from 'jotai';

export type TCallScriptPanelState = Readonly<{
  isAvailable: boolean;
  isOpen: boolean;
}>;

export const INITIAL_CALL_SCRIPT_PANEL_STATE = {
  isAvailable: false,
  isOpen: true,
} satisfies TCallScriptPanelState;

export const callScriptPanelAtom = atom<TCallScriptPanelState>(INITIAL_CALL_SCRIPT_PANEL_STATE);
